import Expert from '@/api/currentExpert'

const DASHBOARD_PLATFORM_DISTRIBUTION_DATE = new Date('2021-10-27T00:00:00.000Z')

export default ({ user, platform }) => {
  const isAdmin = Expert.isAdmin(user)
  const isRestricted = Expert.isRestricted(user)
  const isMulti = platform.multi_experts

  return {
    customers: {
      view: isAdmin
    },
    feedbacks: {
      edit: isAdmin,
      editPublished: isAdmin,
      viewBlocked: isAdmin
    },
    messenger: {
      use: !isRestricted
    },
    platformDistribution: {
      view: isAdmin && isMulti && new Date(platform.created_at) > DASHBOARD_PLATFORM_DISTRIBUTION_DATE
    },
    platformIncomes: {
      view: isAdmin
    },
    platformTraffic: {
      view: isAdmin
    },
    platformAvailabilities: {
      view: isMulti
    },
    platform: {
      customize: isAdmin,
      admin: isAdmin
    },
    links: {
      customize: isAdmin
    },
    services: {
      update: isAdmin,
      assign: isMulti && isAdmin
    },
    team: {
      manage: isAdmin && isMulti,
      viewStats: isAdmin && isMulti
    },
    transfers: {
      manage: platform.settings.payment_provider !== 'payline'
    },
    call: {
      listen: isAdmin
    }
  }
}



// WEBPACK FOOTER //
// ./src/authorisations/index.js